import { getActivePinia } from 'pinia'

/**
 * Execute a callback on a store only if it's already initialized.
 * Prevents first-time store initialization outside Vue context (e.g., during sign-out).
 * @param {Function} useStoreFn - Pinia store composable (e.g., useCartStore)
 * @param {Function} callback - Receives the store instance as argument
 */
export function ifStoreIsActive(useStoreFn, callback) {
  if (getActivePinia()?._s?.has(useStoreFn.$id)) {
    callback(useStoreFn())
  }
}
